export const hasSubjectInLoadedSubjects = (subject, loadedSubjects) =>
    loadedSubjects.find((loadedSubject) => loadedSubject.subject === subject);
